import React from 'react';

import { Checkbox } from 'components/WrappedComponents';
import { FieldProps } from 'components/WrappedComponents/Form/FormWrapper/type';
import { CreationCompteFormValues } from 'types/Compte/CreationCompte';
import { CSSUtils } from 'utils/CSSUtils';

function CheckboxGestionnaireLocal({
  values,
}: FieldProps<CreationCompteFormValues>): React.ReactElement {
  const key: keyof CreationCompteFormValues = 'gestionnaireLocal';

  return (
    <Checkbox
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Gestionnaire local',
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      checkboxProps={{}}
    />
  );
}

export default CheckboxGestionnaireLocal;
